import o from "./index675.js";
import { withInstall as r } from "./index604.js";
const a = r(o);
export {
  a as ElScrollbar,
  a as default
};
